import * as React from 'react';
import { TileWrapper } from './TypographyTile_SC';

export interface Props {
  children?: React.ReactNode;
  size?: number;
  stretch?: boolean;
  flexDirection?: 'column' | 'row';
  justifyContent?: 'flex-start' | 'center' | 'flex-end';
  alignItems?: 'flex-start' | 'center' | 'flex-end';
}

export const TypographyTile: React.FC<Props> = (props) => {
  const { size = 144, children, stretch, flexDirection = 'row', justifyContent = 'center', alignItems = 'center' } = props;

  return (
    <TileWrapper stretch={stretch} size={size} flexDirection={flexDirection} justifyContent={justifyContent} alignItems={alignItems}>
      {children}
    </TileWrapper>
  );
};
